var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFillModelProfile = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 160,
    width: 320,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(42 11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.955 116.57H60.225a4.4 4.4 0 0 1-4.395-4.396V6.899a3.224 3.224 0 0 1 3.22-3.22h173.025a3.28 3.28 0 0 1 3.276 3.275v105.22a4.4 4.4 0 0 1-4.396 4.396z",
    fill: "#9ea6b5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.727 110.345H65.612c-2.333 0-4.23-1.777-4.23-3.962V14.708c0-1.62 1.406-2.937 3.134-2.937h161.255c1.757 0 3.186 1.34 3.186 2.986v91.626c0 2.185-1.897 3.962-4.23 3.962z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.29 6.647H55.768V4.41A4.416 4.416 0 0 1 60.18 0h170.698a4.415 4.415 0 0 1 4.412 4.41z",
    fill: "#5e667d"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 63.786,
    cy: 3.33,
    r: 1.141
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68.118,
    cy: 3.33,
    r: 1.141
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.449,
    cy: 3.33,
    r: 1.141
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.008 93.294H51.355a4.668 4.668 0 0 1-4.662-4.663v-46.93a3.49 3.49 0 0 1 3.486-3.487h41.949a3.547 3.547 0 0 1 3.542 3.543V88.63a4.668 4.668 0 0 1-4.662 4.663z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M91.008 93.294H51.355a4.668 4.668 0 0 1-4.662-4.663v-46.93a3.49 3.49 0 0 1 3.486-3.487h41.949a3.547 3.547 0 0 1 3.542 3.543V88.63a4.668 4.668 0 0 1-4.662 4.663zM50.179 38.747a2.957 2.957 0 0 0-2.954 2.954v46.93a4.134 4.134 0 0 0 4.13 4.13h39.653a4.134 4.134 0 0 0 4.13-4.13V41.757a3.013 3.013 0 0 0-3.01-3.01z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71.181,
    cy: 60.033,
    fill: "#6c63ff",
    r: 8.185
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.295 79.66H58.068v-.083a9.114 9.114 0 0 1 9.104-9.104h8.018a9.114 9.114 0 0 1 9.105 9.104z",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.316 75.5a2.679 2.679 0 0 1-3.773-1.626l-9.511-.415 2.901-4.007 8.587 1.008a2.694 2.694 0 0 1 1.796 5.04z",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.91 71.702 16.678 61.63a8.344 8.344 0 0 1 .683-8.802 11.1 11.1 0 0 1 .588-.72 8.098 8.098 0 0 1 6.68-2.688 8.366 8.366 0 0 1 6.425 3.752l2.511 3.797c.257.23 3.715 3.42 2.429 7.572l-.221 3.98a1.205 1.205 0 0 1-.926 1.102l-11.603 2.695a1.197 1.197 0 0 1-1.336-.615z",
    fill: "#d0cde1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.24 90.82a2.679 2.679 0 0 1 .419-4.087l-2.46-9.198 4.694 1.565 1.616 8.494a2.694 2.694 0 0 1-4.268 3.225z",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.088 86.468a1.19 1.19 0 0 1-.656-.884l-1.619-15.708a13.41 13.41 0 0 1-.095-3.86l1.94-11.754a2.688 2.688 0 0 1 5.337.634l-1.584 13.483 1.815 15.903c.058.489-.191.962-.626 1.193l-3.432.98a1.185 1.185 0 0 1-1.08.013z",
    fill: "#d0cde1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.093 134.37 3.21-.61-.821-12.666-4.736.898z",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.076 133.477 6.32-1.199a4.1 4.1 0 0 1 4.79 3.264l.026.131-10.347 1.962z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.696 134.47 3.266-.001 1.554-12.598h-4.82z",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.863 133.403h6.432a4.1 4.1 0 0 1 4.1 4.099v.133H13.863z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.253,
    cy: 40.051,
    fill: "#ffb8b8",
    r: 6.543
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.158 129.406a1.205 1.205 0 0 1-.318-.907l4.454-40.429c-.039-.378-.643-7.243 4.265-16.026l.027-.049 13.152-3.647 1.455 6.134 9.746 53.34a1.195 1.195 0 0 1-1.014 1.317l-3.392.509a1.2 1.2 0 0 1-1.329-.849L29.72 92.825a.4.4 0 0 0-.767-.003l-9.423 36.101c-.15.511-.618.863-1.151.865h-3.343a1.2 1.2 0 0 1-.877-.382z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.956 74.771-14.172-2.43a4.638 4.638 0 0 1-3.773-3.629l-2.959-13.976a3.812 3.812 0 0 1 3.574-4.598 3.832 3.832 0 0 1 3.942 3.358l1.485 12.457L42.554 69.2c.485.167.81.624.808 1.136l-.005 3.256a1.198 1.198 0 0 1-1.401 1.178z",
    fill: "#d0cde1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.819 38.532c1.041-.216 2.054-.909 2.332-1.935.243-.897-.116-1.864-.679-2.603a5.258 5.258 0 0 0-6.3-1.486c.1-.529-.297-1.05-.786-1.275a3.664 3.664 0 0 0-1.587-.213c-1.702.024-3.515.081-4.922 1.039-1.123.764-1.835 2.02-2.204 3.326-.37 1.306-.43 2.677-.488 4.033-.102 2.378.83 7.381.83 7.381s3.293.906 4.736 1.325c1.551.45 4.167.902 5.718 1.353.397.115.928.18 1.128-.182.159-.29-.025-.641-.21-.914-.816-1.203-1.75-2.337-2.377-3.648-.627-1.31-.92-2.868-.382-4.217.538-1.35 4.15-1.77 5.19-1.984z",
    fill: "#585ddb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.56 84.575h85.21a4.263 4.263 0 0 0 4.262-4.263v-38.51a4.263 4.263 0 0 0-4.262-4.262h-85.21a4.263 4.263 0 0 0-4.263 4.263v38.51a4.263 4.263 0 0 0 4.262 4.262z",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.466 63.189H140.53a2.131 2.131 0 1 1 0-4.263h67.936a2.131 2.131 0 1 1 0 4.263zm0 9.058H140.53a2.131 2.131 0 0 1 0-4.263h67.936a2.131 2.131 0 1 1 0 4.263zM196.478 54.13H140.53a2.131 2.131 0 1 1 0-4.262h55.948a2.131 2.131 0 1 1 0 4.263z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.94 138H.266a.266.266 0 0 1 0-.533H63.94a.266.266 0 1 1 0 .533z",
    fill: "#061437",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    d: "m187.425 36.678 1.32 1.909h-1.761l-.44-.635-.713 1.033.536.775h4.617l-2.847-4.115zm-3.63-2.702-1.255-1.816h-1.428l2.683 3.881 3.496-5.056 1.761-.001-5.257 7.603-5.256-7.6 4.95-.002.749 1.084.713-1.033-.848-1.228h-7.806l7.498 10.843 7.502-10.843h-4.622z",
    fill: "#ff4d3c"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(94.176 56.73)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39 19.5a19.448 19.448 0 0 1-1.416 7.31l-.007.015a19.414 19.414 0 0 1-3.3 5.398 19.501 19.501 0 0 1-1.554 1.609l-.073.067a19.49 19.49 0 0 1-3.458 2.526 18.317 18.317 0 0 1-1.294.678c-.08.04-.162.077-.244.115a19.32 19.32 0 0 1-3.315 1.177l-.019.004a14.154 14.154 0 0 1-.415.1c-.116.028-.232.054-.349.078l-.197.04c-.04.01-.08.017-.12.024l-.15.029-.084.015a26.598 26.598 0 0 1-.513.087 16.45 16.45 0 0 1-.512.071l-.077.01a633.137 633.137 0 0 0-.298.034 11.404 11.404 0 0 1-.556.052 18.4 18.4 0 0 1-.31.022l-.202.012a19.156 19.156 0 0 1-.776.025h-.002a19.627 19.627 0 0 1-4.837-.539l-.186-.045-.163-.043a19.348 19.348 0 0 1-4.074-1.569l-.02-.01-.11-.059a19.429 19.429 0 0 1-1.916-1.162l-.105-.073c-.036-.025-.073-.05-.108-.076a19.235 19.235 0 0 1-1.417-1.105 19.6 19.6 0 0 1-4.359-5.321A19.407 19.407 0 0 1 0 19.5C0 8.73 8.73 0 19.5 0S39 8.73 39 19.5z",
    fill: "#ff4d3c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.636 38.46.185-.046.164-.043.011-.378a83.934 83.934 0 0 1 .576-7.419l.01-.076a71.986 71.986 0 0 1 .484-3.291l.017-.098a53.926 53.926 0 0 1 .286-1.535 48.53 48.53 0 0 1 .96-3.967c.385-1.35.857-2.672 1.416-3.958.433-1 .95-1.962 1.543-2.875l.026-.04c.758-1.142 1.625-2.112 2.615-2.837l-.205-.28c-.948.695-1.818 1.62-2.61 2.774l-.011.017a18.89 18.89 0 0 0-1.554 2.784 30.427 30.427 0 0 0-1.481 4.002 47.61 47.61 0 0 0-1.018 4.13 62.547 62.547 0 0 0-.351 1.885v.004a68.507 68.507 0 0 0-.528 3.7 77.412 77.412 0 0 0-.182 1.714l-.009.089-.014.151a82.122 82.122 0 0 0-.33 5.592zm4.422-1.658.02-.01c.119-.062.236-.125.354-.19.039-.46.09-.965.159-1.497l.045-.333.025-.182c.068-.468.149-.952.246-1.438.394-1.982 1.048-4.008 2.135-5.259a3.958 3.958 0 0 1 .676-.631l-.206-.28a4.446 4.446 0 0 0-.68.623c-.073.08-.143.164-.212.25-1 1.259-1.624 3.122-2.012 4.966a27.058 27.058 0 0 0-.313 1.793 34.392 34.392 0 0 0-.237 2.188z",
    fill: "#000",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.87,
    cy: 10.153,
    fill: "#000",
    opacity: 0.2,
    r: 1.736
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.311,
    cy: 25.096,
    fill: "#000",
    opacity: 0.2,
    r: 1.736
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.978 13.069c.368 2.076-.444 3.957-.444 3.957s-1.41-1.487-1.778-3.564c-.368-2.076.445-3.957.445-3.957s1.409 1.487 1.777 3.564zm5.769 4.929c-1.98.725-3.971.26-3.971.26s1.22-1.64 3.202-2.364c1.98-.724 3.971-.26 3.971-.26s-1.221 1.64-3.202 2.364zm.336 13.232c-1.388.508-2.786.177-2.786.177s.854-1.154 2.243-1.662 2.785-.176 2.785-.176-.854 1.154-2.242 1.662z",
    fill: "#000",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.382 30.939.1.036c-.01.075-.033.121-.1-.036z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.504 30.963c0 .008.003.017.004.025l-.043-.013c0-.008.002-.016.004-.024.01-.1-.002-.22.035.012z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.982,
    cy: 18.729,
    fill: "#2f2e41",
    r: 9.474
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.762,
    cy: 22.08,
    fill: "#d0cde1",
    r: 5.737
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.862 33.076-.007.001-1.335.32-2.778.667-.38.092-4.224 1.013-.36.087-10.25 2.46c-.694-.265-1.37-.57-2.029-.914l-.02-.01-.11-.059a19.429 19.429 0 0 1-1.916-1.162l-.105-.073c-.036-.025-.073-.05-.108-.076a21.24 21.24 0 0 1-.284-.205c.996-1.81 3.367-3.013 5.738-3.67 1.79-.498 2.183-2.133 2.149-3.587a9.662 9.662 0 0 0-.428-2.534l5.737.192.592 1.364c-.016.15-.021.3-.015.45.045 1.12.735 1.843 1.587 2.31.111.06.225.117.34.17 1.397.634 3.042.678 3.042.678a5.857 5.857 0 0 1 1.505.028 5.086 5.086 0 0 1 2.206.895c.212.151.413.318.6.498.334.312.621.67.853 1.065z",
    fill: "#d0cde1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.723 33.832-.073.067a19.49 19.49 0 0 1-3.458 2.526 18.317 18.317 0 0 1-1.294.678l-.244-.202 2.866-3.504.577-.704s.23 0 .758.384c.292.217.567.455.825.712l.043.043z",
    fill: "#d0cde1"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#2f2e41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.682 33.793a.657.657 0 0 1-.032.106 19.49 19.49 0 0 1-1.595 1.31c-.481.173-.98.292-1.488.353 0 0 .043.217.082.592a18.79 18.79 0 0 1-1.317.736 14.624 14.624 0 0 1-.434.213c-.08.04-.162.077-.244.115a19.32 19.32 0 0 1-3.315 1.177l-.019.004a14.154 14.154 0 0 1-.415.1c-.116.028-.232.054-.349.078l-.197.04c-.04.01-.08.017-.12.024l-.15.029-.084.015a26.598 26.598 0 0 1-.513.087 16.45 16.45 0 0 1-.512.071l-.077.01a633.137 633.137 0 0 0-.298.034 11.404 11.404 0 0 1-.556.052 18.4 18.4 0 0 1-.31.022l-.202.012a19.156 19.156 0 0 1-.776.025h-.002a19.567 19.567 0 0 1-4.837-.539l-.186-.045-.163-.043a19.348 19.348 0 0 1-4.074-1.569l-.02-.01-.11-.059a4222.892 4222.892 0 0 1 12.876-2.981 1251.876 1251.876 0 0 1 4.763-1.084c1.366-.307 2.426-.54 3.002-.657.155-.035.311-.063.47-.082l1.2 1.86z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.314,
    cy: 11.876,
    r: 2.822
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.649,
    cy: 11.07,
    r: 2.822
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.626 9.86a2.822 2.822 0 0 1 2.52-2.805 2.822 2.822 0 1 0 0 5.61 2.822 2.822 0 0 1-2.52-2.805zM6.161 14.159a2.822 2.822 0 0 1-.163-3.767 2.822 2.822 0 1 0 3.926 4.007 2.822 2.822 0 0 1-3.763-.24zm11.821.136c-3.34 0-6.047 1.58-6.047 3.527 0 .872.544 1.669 1.442 2.284l1.164-.843-.316 1.321c.131.06.265.12.405.174l1.74-2.029v2.493c.532.085 1.072.128 1.612.128 3.34 0 6.047-1.58 6.047-3.528s-2.708-3.527-6.047-3.527z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.827 11.07s-.438 2.015 2.3 2.822zm-11.892.367s1.008 2.253-2.016 3.261z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.12,
    cy: 23.227,
    fill: "#d0cde1",
    rx: 1,
    ry: 1.147,
    transform: "rotate(-15.639 13.12 23.227)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.594,
    cy: 22.271,
    fill: "#d0cde1",
    rx: 1.147,
    ry: 1,
    transform: "rotate(-86.476 24.594 22.27)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFillModelProfile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/fill-model-profile.d78898c539f8d1465dbd66958ea0f695.svg";